// LIB
import React from 'react';
import styled from 'styled-components';

// STYLES
import { colors, fontFamily, fontSize } from '../../Design_System/DesignSystem';

// COMPONENT
import { Text } from '../atoms/Text';
import { useLanguage } from '../../i18n/LanguageContext';

interface HomeProps {
  setSelectedItem: React.Dispatch<React.SetStateAction<number>>;
}

const Info = ({ setSelectedItem }: HomeProps) => {
  const { t } = useLanguage();
  return (
    <Container>
      <Formations>
        <Formation>
          <Text
            color={colors.tan}
            fontSize={fontSize.small}
            fontFamily={fontFamily.playfair}
            justify
            bold={true}
          >
            2023 - 2024 France Travail
          </Text>
          <Text
            color={colors.tan}
            fontSize={fontSize.small}
            fontFamily={fontFamily.playfair}
            justify
            bold={false}
          >
            {t.info.careerCounselor}{' '}
            {/*             <EasterEgg onClick={() => setSelectedItem(4)}>🐆</EasterEgg> */}
          </Text>
        </Formation>
        <Formation>
          <Text
            color={colors.tan}
            fontSize={fontSize.small}
            fontFamily={fontFamily.playfair}
            justify
            bold={true}
          >
            2019 - 2022 Ouihelp
          </Text>
          <Text
            color={colors.tan}
            fontSize={fontSize.small}
            fontFamily={fontFamily.playfair}
            justify
            bold={false}
          >
            {t.info.softwareEngineer}
          </Text>
        </Formation>
        <Formation>
          <Text
            color={colors.tan}
            fontSize={fontSize.small}
            fontFamily={fontFamily.playfair}
            justify
            bold={true}
          >
            2018 - 2021 HETIC
          </Text>
          <Text
            color={colors.tan}
            fontSize={fontSize.small}
            fontFamily={fontFamily.playfair}
            justify
            bold={false}
          >
            Bachelor WEB Fullstack / Design
          </Text>
        </Formation>
        <Formation>
          <Text
            color={colors.tan}
            fontSize={fontSize.small}
            fontFamily={fontFamily.playfair}
            justify
            bold={true}
          >
            2015 - 2017 Kaféin Studio
          </Text>
          <Text
            color={colors.tan}
            fontSize={fontSize.small}
            fontFamily={fontFamily.playfair}
            justify
            bold={false}
          >
            {t.info.trainee}
          </Text>
        </Formation>
        <Formation>
          <Text
            color={colors.tan}
            fontSize={fontSize.small}
            fontFamily={fontFamily.playfair}
            justify
            bold={true}
          >
            2015 - 2018 Louis Armand
          </Text>
          <Text
            color={colors.tan}
            fontSize={fontSize.small}
            fontFamily={fontFamily.playfair}
            justify
            bold={false}
          >
            BTS SIO Options SLAM
          </Text>
        </Formation>
      </Formations>
      <StackFront>
        <Text
          color={colors.tan}
          fontSize={fontSize.small}
          fontFamily={fontFamily.playfair}
          justify
          bold={true}
        >
          {t.info.stackFront}
        </Text>
        <Text
          color={colors.tan}
          fontSize={fontSize.small}
          fontFamily={fontFamily.playfair}
          justify
          bold={false}
        >
          <>
            HTML / CSS / SASS / JS
            <br />
            React / React Native
            <br />
            Typescript
            <br />
            StoryBook
          </>
        </Text>
      </StackFront>
      <StackBack>
        <Text
          color={colors.tan}
          fontSize={fontSize.small}
          fontFamily={fontFamily.playfair}
          justify
          bold={true}
        >
          {t.info.stackBack}
        </Text>
        <Text
          color={colors.tan}
          fontSize={fontSize.small}
          fontFamily={fontFamily.playfair}
          justify
          bold={false}
        >
          <>
            MySQL / PostgreSQL
            <br />
            SQLAlchemy
            <br />
            Python / Flask
            <br />
            PHP / Symphony
          </>
        </Text>
      </StackBack>
    </Container>
  );
};

const Formations = styled.div`
  border-bottom: solid 1px ${colors.tan};
  padding-bottom: 10px;
`;

const StackFront = styled.div`
  border-bottom: solid 1px ${colors.tan};
  margin-top: 10px;
  padding-bottom: 10px;
`;

const Formation = styled.div`
  margin-bottom: 10px;
`;

const StackBack = styled.div`
  margin-top: 10px;
`;

const Container = styled.div`
  margin: 20px;
  height: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: end;
`;
/* const EasterEgg = styled.span`
  opacity: 0.2;
  cursor: pointer;
`; */

export default Info;
